module.exports = __webpack_public_path__ + "static/teck_4-06adde7b50aea58ec9037a710e50cc47.jpg";